import React, {useState, Component, useEffect} from 'react'
import { Link } from 'react-router-dom'
import GuideSubmit from './GuideSubmit'
import GuideConfirm from './GuideConfirm';
import history from "../../route/history";

const Guide = () => {
  const [page , setPage ] = useState("confirm");

  const confirmPage = () => {
   setPage("")
  };

  const submitPage = () => {
   setPage("submit")
  };

  const prePage = (e) => {
    e.preventDefault();
    window.history.back()
  }


    return (
        <React.Fragment>
          <main>
            <div id="contents">
              <div className="content-header">
                <a className="page-prev" onClick={prePage}>뒤로이동</a> {/* mobile */}
                <h2>이용안내</h2>
                <div className="breadcrumb">
                  <span>Home</span><span>고객센터</span><em>이용안내</em>
                </div>
              </div>
    
              <div className="notice-tab">
                <ul className='nav-tab mt40'>
                    <li><Link title="공지사항" to="/notice">공지사항</Link></li>
                    <li><Link title="FAQ" to="/faq">FAQ</Link></li>
                    <li><Link title="문의하기" to="/question">문의하기</Link></li>
                    <li><Link title="자료실" to="/reference">자료실</Link></li>
                    <li className="on"><Link title="이용안내" to="/guide">이용안내</Link></li>
                </ul> 
              </div>
              {
                page ?
                <GuideSubmit page={page} confirmPage={confirmPage} submitPage={submitPage}/>
                : <GuideConfirm page={page} confirmPage={confirmPage} submitPage={submitPage}/>
              }
            </div>
          </main>
        </React.Fragment>
    )
  }
  export default Guide